export class CriacaoContaCliente {
  Email: string;
  NomeEscritorio: string;

  constructor(email: string = "", nomeEscritorio: string = "") {
    this.Email = email;
    this.NomeEscritorio = nomeEscritorio;
  }
}